import { loginFunction } from "./login";
import { lostPassword } from "./lost-password";


export function authFunctionality(){
    loginFunction()
    lostPassword()
    tOnlineCheck()
}


function tOnlineCheck(){
$("input[type='email']").on("blur change input", function(){
    const tonline = $("#t-online-warning");
    if (tonline.length > 0){
    if ($(this).val().includes("t-online")){
        tonline.removeClass("hide");
    } else {
        if (!tonline.hasClass("hide")){
            tonline.addClass("hide");
        }
    }
    }
})
}